<div class="d-flex flex-column" [class.disabled]="!layerAvailable">
    <div style=" display: flex; justify-content: space-between;">
        <a class="hs-catalogue-list-item-title" data-toggle="tooltip" [title]="layer.abstract || ''">{{layer.title ||
            layer.abstract}}</a>
        <!-- STATUS BADGE -->
        <span class="badge rounded-pill w-auto" *ngIf="!layerAvailable" [ngClass]="{
            'bg-danger':layer.wfsWmsStatus === 'NOT_AVAILABLE',
            'bg-warning':layer.wfsWmsStatus === 'PREPARING'
        }"> {{layer.wfsWmsStatus | translateHs:{ 'module' :'COMMON'} }}</span>
    </div>
    <div class="hs-catalogue-item-body d-flex flex-column w-100 justify-content-around mt-2"
        *ngIf="hsAddDataCatalogueService.selectedLayer?.id === layer.id">
        <hr class="hs-dotted-line w-100 ">
        <div class="d-flex flex-row justify-content-around align-items-end">
            <a class="btn btn-sm border-0" [class.disabled]="!layerAvailable" [hidden]="selectTypeToAddLayerVisible"
                [ngClass]="{'text-muted': layerAvailable}"
                (click)="$event.stopPropagation();addLayerToMap(layer.endpoint, layer)">
                <i [hidden]="loadingInfo" class="icon-plus icon-primary"></i>
                <span [hidden]="!loadingInfo" class="hs-loader"></span>
                <span *ngIf="layerAvailable" class="ms-1">{{'COMMON.addToMap' |
                    translateHs }}</span>
            </a>
            <a class="btn btn-sm border-0" [title]="'DATASOURCE_SELECTOR.datasourceListItem.abortAdd' | translateHs "
                (click)="$event.stopPropagation();abortAdd()" [hidden]="!selectTypeToAddLayerVisible">
                <i class="icon-remove text-danger"></i><span
                    class="ms-1">{{'DATASOURCE_SELECTOR.datasourceListItem.abortAdd' |
                    translateHs }}</span>
            </a>
            <a class="btn btn-sm border-0" (click)="showMetadata(layer.endpoint, layer)">
                <i class="icon-info-sign icon-primary"></i><span class="ms-1">{{'COMMON.metadata' |
                    translateHs }}</span>
            </a>
            <a class="btn btn-sm border-0" (click)="$event.stopPropagation();showPermissions(layer)"
                data-toggle="tooltip" data-placement="bottom"
                [title]="layer.editable ? '' : 'DATASOURCE_SELECTOR.datasourceListItem.notAllowedToEditLayer' | translateHs ">
                <i class="icon-lock icon-primary" [ngClass]="{'text-muted': !layer.editable}"
                    [ngStyle]="{'cursor' : layer.editable ? 'pointer' : 'default'}"></i><span class="ms-1"
                    *ngIf="layer.editable">{{'COMMON.setPermissions' | translateHs }}</span>
            </a>
            <a class="btn btn-sm border-0" (click)="$event.stopPropagation();removeLayer(layer)" data-toggle="tooltip"
                data-placement="bottom"
                [title]="layer.editable ? '' : 'DATASOURCE_SELECTOR.datasourceListItem.notAllowedToEditLayer' | translateHs ">
                <i class="icon-trash text-danger" [ngClass]="layer.editable ? 'text-danger' : 'text-muted'"
                    [ngStyle]="{'cursor' : layer.editable ? 'pointer' : 'default'}"></i><span class="ms-1"
                    *ngIf="layer.editable">{{'COMMON.removeLayer' | translateHs }}</span>
            </a>
        </div>
    </div>
    <div class="d-none">
        <div class="p-0" [hidden]='hsAddDataCatalogueService.layerDownload(layer.endpoint,layer) === "#"'>
            <!-- TODO: Remove function call from template -->
            <a class="btn btn-sm border-0 btn-secondary"
                [href]='hsAddDataCatalogueService.layerDownload(layer.endpoint, layer)' data-toggle="tooltip"
                [title]="'COMMON.download' | translateHs "><i class="icon-download"></i></a>
        </div>
        <!-- <div class="p-0" [hidden]='getEndpoint(layer.endpoint).type != "micka" || layerRDF(layer.endpoint, layer) == "#"'>
            <a class="btn btn-sm btn-secondary" [href]='layerRDF(layer.endpoint, layer)'
                data-toggle="tooltip" title="GeoDCAT-AP" target="_blank"><i class="icon-share-alt"></i></a>
        </div> -->
    </div>
</div>
<div>
    <!-- <div class="p-0" [hidden]="!selectTypeToAddLayerVisible || selectedType">
        <button type="button" class="btn btn-sm btn-danger" (click)="$event.stopPropagation();abortAdd()" data-toggle="tooltip"
            [title]="'DATASOURCE_SELECTOR.datasourceListItem.abortAdd' | translateHs ">
            <i class="icon-remove"></i>
        </button>
    </div> -->
    <div [hidden]="!loadingInfo" class="list-group-item text-primary text-center py-2">
        <span class="pe-2 hs-loader hs-loader-dark"></span>
        &emsp;{{'ADDDATA.CATALOGUE.loading' | translateHs }}
    </div>
    <div class="card bg-light align-items-center"
        [hidden]="!selectTypeToAddLayerVisible || loadingInfo || hsAddDataCatalogueService.selectedLayer?.id !== layer.id">
        <div class="d-flex flex-row justify-content-between align-items-center w-100">
            <div class="px-3">
                <span class="btn btn-sm disabled border-0" disabled="true" aria-disabled="true">{{
                    'COMMON.addAs' |
                    translateHs }}&nbsp;</span>
                <div class="btn-group btn-group-toggle h-100 pe-2 align-items-center" data-toggle="buttons">
                    <label class="btn btn-sm btn-outline-secondary" *ngFor="let type of whatToAddTypes"
                        style="width:6em" (click)="selectTypeAndAdd(type,$event)">
                        {{type}}
                    </label>
                </div>
            </div>
            <div>
                <a class="btn btn-sm border-0" (click)="$event.stopPropagation();toggleExplanations()"
                    [title]="'DATASOURCE_SELECTOR.datasourceListItem.whatDoesItMean' | translateHs ">
                    <i class="icon-question-sign text-primary"></i>
                </a>
            </div>
        </div>
        <div class="d-flex">
            <ul class="ms-auto p-2 list-unstyled" [hidden]="!explanationsVisible">
                <li class="text-secondary small" *ngFor="let type of whatToAddTypes">
                    {{type}} &ndash; {{translateString('ADDDATA.CATALOGUE.DESC', type)}}
                    <!-- TODO: Remove function call from template -->
                </li>
            </ul>
        </div>
    </div>

</div>